import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { ExpandingWildsBulkFactory, ExpandingWildsBulk, ExpandingWildsBulkParam, ExpandingWildsBulkConfig } from "../../slot/ExpandingWildBulk";
import { Rect } from "../.././MyHelpers";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
//namespace SlotGames {
export class FireBlastClassic_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {


	protected override helpFactory: IHelpFactory = new FireBlastClassicHelpFactory();
	protected override expandingWildsFactory: ExpandingWildsBulkFactory = new FireBlastClassicExpandingWildsBulkFactory();

	constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
		super(multigameParams, initData, "FireBlastClassic");
		this.spinnableReelsParams.topBorderWidth = 0;
		this.spinnableReelsParams.bottomBorderWidth = 0;
	}

	// public PrepareFont(resourceManager: ResourceManager)
	// {
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName("font")));
	// 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
	// }
	//SEND COLOR 
	protected override color: RewardColor =
		{
			color: "white",
			coloroutherStroke: "black",
			colorinnerStroke: "red",
		}

	protected override colorLineMarkers: MarkersInfoColors =
		{
			MarkerbackgroundColor: "linear-gradient(90deg, rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};
}

//Help Colorized
class FireBlastClassicHelpFactory implements IHelpFactory {
	public CreateNewHelp(params: HelpParameters): Help {
		return new FireBlastClassicHelp(params);
	}
}

class FireBlastClassicHelp extends Help {
	protected override BackgroundPanel(): HelpPanelColor {
		let color: HelpPanelColor = {
			backgroundPanelColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

		return color;
	}
}

class FireBlastClassicExpandingWildsBulkFactory extends ExpandingWildsBulkFactory {
	public override CreateExpandingWildsBulk(param: ExpandingWildsBulkParam, config: ExpandingWildsBulkConfig): ExpandingWildsBulk {
		return new FireBlastClassicExpandingWildsBulk(param, config);
	}

}

class FireBlastClassicExpandingWildsBulk extends ExpandingWildsBulk {
	public override InflateWildSize(wildRect: Rect): Rect {
		return wildRect;
	}
}

//}
